<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                  :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
    >
      <a-form-model-item label="供应商名称" prop="providerName">
        <a-input placeholder="仅用于区分标识数据来源，6个字内" v-model.trim="ruleForm.providerName"/>
      </a-form-model-item>
      <a-form-model-item label="接口域名" prop="providerUrl">
        <a-input placeholder="请输入" v-model.trim="ruleForm.providerUrl"/>
      </a-form-model-item>
      <a-form-model-item label="用户名" prop="partnerUser">
        <a-input placeholder="请输入" v-model.trim="ruleForm.partnerUser" :maxLength="30"/>
      </a-form-model-item>
      <a-form-model-item label="密码" prop="partnerPwd">
        <a-input placeholder="请输入" v-model.trim="ruleForm.partnerPwd" :maxLength="30"/>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
      </a-form-model-item>
    </a-form-model>
    <search-page-view
      ref="table"
      rowKey="providerId"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <div slot="action" slot-scope="data">
        <a @click="editEvent(data.record.providerId)">编辑</a>
        <a-divider type="vertical"></a-divider>
        <a v-if="data.record.status==0" @click="handleEvent(data.record.providerId,1)">启用</a>
        <a v-else @click="handleEvent(data.record.providerId,0)">禁用</a>
      </div>
    </search-page-view>
  </a-card>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'RelevanceAccount',
  mixins: [ruleFormMixins],
  components: {},
  data() {
    return {
      queryParams: {},
      submitLoading: false,
      ruleForm: {
        partnerPwd: '',// 密码
        partnerUser: '',// 用户名
        providerId: '',//关联账号ID
        providerName: '',// 供应商名称(账户名称)
        providerUrl: ''// 接口域名
      },
      rules: {
        providerName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        providerUrl: [
          { required: true, message: '请输入域名Url', trigger: 'blur' }
        ],
        partnerUser: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        partnerPwd: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'providerName'
        },
        {
          title: '接口域名',
          dataIndex: 'providerUrl'
        },
        {
          title: '用户名',
          dataIndex: 'partnerUser'
        },
        {
          title: '密码',
          dataIndex: 'partnerPwd'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'RewardBindPro', title: '商品绑定' },
      { name: 'zhRewardOrder', title: '订单直连' },
      { name: 'RelevanceAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getProService().post('airlineProvider/getAirlineProviderVo', params)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getProService().post('airlineProvider/editProvider', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    editEvent(id) {
      this.getHttpServices().getProService().post('airlineProvider/getProviderInfoVo/' + id, {}).then(res => {
        this.getLogUtils().logWithTag('editEvent', res)
        this.ruleForm = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 操作
    handleEvent(id, status) {
      let text = status == 1 ? '启用' : '禁用'
      let that = this
      this.$confirm({
        title: '此操作将' + text + '该供应商?，是否继续',
        onOk() {
          that.getUpdateStatus(id)
        },
        onCancel() {
          that.$message.info('已取消')
        }
      })
    },
    getUpdateStatus(id) {
      this.getHttpServices().getProService().post('airlineProvider/updateStatus/' + id, {}).then(res => {
        this.$message.success('操作成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">
input {
  max-width: 400px;
}
</style>